import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import api from "../api/axios";

import AdminHeader from "../components/AdminPanel/AdminHeader";
import DashboardSection from "../components/AdminPanel/DashboardSection";
import UsersSection from "../components/AdminPanel/UsersSection";
import SlidersSection from "../components/AdminPanel/SlidersSection";
import ProductSection from "../components/AdminPanel/ProductSection";
import CategoriesSection from "../components/AdminPanel/CategoriesSection";
import BrandsSection from "../components/AdminPanel/BrandsSection";
import TestimonialsSection from "../components/AdminPanel/TestimonialsSection";
import InfoSection from "../components/AdminPanel/InfoSection";
import ContactSection from "../components/AdminPanel/ContactSection";
import DownloadSection from "../components/AdminPanel/DownloadSection";
import TeamsSection from "../components/AdminPanel/TeamsSection";
import DealersSection from "../components/AdminPanel/DealersSection";
import MaintenanceSection from "../components/AdminPanel/MaintenanceSection";
import SettingsSection from "../components/AdminPanel/SettingsSection";
import ProfileSection from "../components/AdminPanel/ProfileSection";
import PanelSideBar from "../components/AdminPanel/PanelSidebar";
//axios.defaults.withCredentials = true;

const SettingsPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState("dashboard");
  const navigate = useNavigate();
  useEffect(() => {
    api.get("companyblog/admin/me/")
      .then(res => {
        setUser(res.data);
        setLoading(false);
      })
      .catch(() => {
        navigate("/admin_login");
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!user.is_staff && !user.is_superuser) {
    return <h2>Unauthorized</h2>;
  }
  
  return (
    <div style={styles.container}>

      {/* Sidebar */}
      <PanelSideBar
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        user={user}
      />

      {/* Right Panels */}
{/*       <div style={styles.contentArea}> */}
{/*          */}{/* Panels */}
{/*         {activeMenu === "users" && <UsersPanel user={user} />} */}
{/*         {activeMenu === "images" && <ImageLogoPanel />} */}
{/*         {activeMenu === "menus" && <MenusPanel />} */}
{/*         {activeMenu === "reports" && <ReportsPanel />} */}
{/*         {activeMenu === "aboutus" && <AboutUsPanel />} */}
{/*       </div> */}
<div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <AdminHeader user={user} />
            <div style={styles.contentArea}>
              {activeMenu === "dashboard" && <DashboardSection />}
              {activeMenu === "users" && <UsersSection />}
              {activeMenu === "sliders" && <SlidersSection />}
              {activeMenu === "products" && <ProductSection />}
              {activeMenu === "categories" && <CategoriesSection />}
              {activeMenu === "brands" && <BrandsSection />}
              {activeMenu === "testimonials" && <TestimonialsSection />}
              {activeMenu === "info" && <InfoSection />}
              {activeMenu === "contact" && <ContactSection />}
              {activeMenu === "upload" && <DownloadSection />}
              {activeMenu === "teams" && <TeamsSection />}
              {activeMenu === "dealers" && <DealersSection />}
              {activeMenu === "maintenance" && <MaintenanceSection />}
              {activeMenu === "settings" && <SettingsSection />}
              {activeMenu === "profile" && <ProfileSection />}
            </div>
    </div>
    </div>
  );
};

// Inline Styles (you can replace with CSS)
const styles = {
  container: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    margin: 0,
    padding: 0,
    backgroundColor: "#f7f8fa",
  },
  backButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    backgroundColor: "#4a63e7",
    color: "white",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
    zIndex: 10,
  },
  contentArea: {
    flex: 1,
    padding: "40px",
    overflowY: "auto",
  },
};

export default SettingsPage;
